import { useEffect, useState } from "react";
import { Activity } from "lucide-react";
import { api } from "@/lib/api";
import { fmtTime } from "@/lib/format";
import { Avatar, AvatarStack } from "@/components/Brand";

export function useCommunity(eventId, tick) {
  const [c, setC] = useState(null);
  useEffect(() => {
    api.get("/community", { params: { event_id: eventId || undefined } }).then((r) => setC(r.data)).catch(() => {});
  }, [eventId, tick]);
  return c;
}

export const ClimbersJoining = ({ c }) => {
  if (!c) return null;
  return (
    <div className="flex items-center gap-3" data-testid="climbers-joining">
      {c.climbers.length > 0 && <AvatarStack names={c.climbers} size={30} />}
      <div className="text-sm font-semibold text-[#1A3323]">
        <span className="font-mono text-base font-extrabold" data-testid="climbers-count">{c.checked_in_count}</span> climber {c.checked_in_count ? "sudah di wall" : "— jadi yang pertama!"}
      </div>
    </div>
  );
};

export function CommunityFeed({ c }) {
  if (!c || (!c.feed.length && !c.climbing_now.length)) return null;
  return (
    <section className="rounded-[22px] bg-white p-4 ring-1 ring-[#1A3323]/10 rise rise-3" data-testid="community-feed">
      <div className="mb-3 flex items-center gap-2 text-xs font-extrabold uppercase tracking-[0.18em] text-[#3D6F4B]">
        <Activity className="h-4 w-4" /> Lagi rame di wall
      </div>
      {c.climbing_now.length > 0 && (
        <div className="mb-3 flex flex-wrap gap-2">
          {c.climbing_now.map((t) => (
            <span key={t.number} className="inline-flex items-center gap-1.5 rounded-full bg-[#E3EDD9] py-1 pl-1 pr-3 text-xs font-bold text-[#1A3323]" data-testid="climbing-now-chip">
              <Avatar name={t.display_name} size={22} /> {t.display_name} · {t.route_name}
            </span>
          ))}
        </div>
      )}
      <ul className="space-y-2.5">
        {c.feed.slice(0, 6).map((f, i) => (
          <li key={i} className="flex items-center gap-2.5 text-sm" data-testid="community-feed-item">
            <Avatar name={f.name} size={30} />
            <div className="min-w-0 flex-1"><b className="text-[#1A3323]">{f.name}</b> {f.text}</div>
            <span className="text-[11px] text-muted-foreground">{fmtTime(f.at)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
